export const FETCH_COMPONENTS_REQUEST = 'FETCH_COMPONENTS_REQUEST';
export const FETCH_COMPONENTS_SUCCESS = 'FETCH_COMPONENTS_SUCCESS';
export const FETCH_COMPONENTS_FAILURE = 'FETCH_COMPONENTS_FAILURE';

export const FETCH_COMPONENT_REQUEST = 'FETCH_COMPONENT_REQUEST';
export const FETCH_COMPONENT_SUCCESS = 'FETCH_COMPONENT_SUCCESS';
export const FETCH_COMPONENT_FAILURE = 'FETCH_COMPONENT_FAILURE';

export const UPDATE_COMPONENTS_REQUEST = 'UPDATE_COMPONENTS_REQUEST';
export const UPDATE_COMPONENTS_SUCCESS = 'UPDATE_COMPONENTS_SUCCESS';
export const UPDATE_COMPONENTS_FAILURE = 'UPDATE_COMPONENTS_FAILURE';

export const DELETE_COMPONENTS_REQUEST = 'DELETE_COMPONENTS_REQUEST';
export const DELETE_COMPONENTS_SUCCESS = 'DELETE_COMPONENTS_SUCCESS';
export const DELETE_COMPONENTS_FAILURE = 'DELETE_COMPONENTS_FAILURE';

export const CLEAR_COMPONENT_ERRORS = 'CLEAR_COMPONENT_ERRORS';
export const CLEAR_COMPONENT_SUCCESS = 'CLEAR_COMPONENT_SUCCESS';